class NewCustomPdpGallery extends HTMLElement {
  constructor() {
    super();
    this.initArrows();
  }

  initArrows() {
    let checkExist = setInterval(() => {
      let buttons = this.querySelectorAll('.flickity-prev-next-button');
      let snippet = this.querySelector('#custom-gallery-arrow-snippet');
      if (buttons.length > 0 && snippet) {
        clearInterval(checkExist);
        let svgHtml = snippet.innerHTML;
        buttons.forEach(btn => {
          if (btn.classList.contains('previous')) {
            btn.innerHTML = svgHtml.replace('<svg ', '<svg style="transform: rotate(180deg); transform-origin: center;" ');
          } else {
            btn.innerHTML = svgHtml;
          }
        });
      }
    }, 100);
  }
}
customElements.define('new-custom-pdp-gallery', NewCustomPdpGallery);

class NewCustomVideoSlider extends HTMLElement {
  constructor() {
    super();
    this.initArrows();
    this.initVideos();
  }
  
  initVideos() {
    const wrappers = this.querySelectorAll('.new-custom-video-carousel__video-wrapper');
    wrappers.forEach(wrapper => {
      const video = wrapper.querySelector('video');
      const playBtn = wrapper.querySelector('.new-custom-video-carousel__play-btn');
      
      if (video && playBtn) {
        wrapper.addEventListener('click', () => {
          if (video.paused) {
            video.play();
            video.controls = true;
            playBtn.style.opacity = '0';
            playBtn.style.pointerEvents = 'none';
          }
        });
      }
    });
  }
  
  initArrows() {
    let checkExist = setInterval(() => {
      let buttons = this.querySelectorAll('.flickity-prev-next-button');
      let configEl = this.querySelector('.video-carousel-arrow-config');
      
      if (buttons.length > 0 && configEl) {
        clearInterval(checkExist);
        
        let svgHtml = configEl.innerHTML;
        let bgColor = configEl.dataset.bg;
        let iconColor = configEl.dataset.icon;
        
        if (iconColor) {
          svgHtml = svgHtml.replace(/#263954/g, iconColor);
        }
        
        buttons.forEach(btn => {
          btn.style.backgroundColor = bgColor;
          if (iconColor) {
            btn.style.borderColor = iconColor;
          }
          btn.innerHTML = svgHtml;
        });
      }
    }, 100);
  }
}
customElements.define('new-custom-video-slider', NewCustomVideoSlider);

class NewCustomBuyBox extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    if (!this.form) return;
    
    this.options = this.querySelectorAll('.custom-bb-option');
    this.qtyInput = this.querySelector('.custom-bb-qty');
    this.spInput = this.querySelector('.custom-bb-sp');
    this.idInput = this.querySelector('.custom-bb-vid');
    this.submitBtn = this.querySelector('.custom-bb-submit');
    this.oneTimeView = this.querySelector('.custom-bb-onetime-view');
    this.oneTimeLink = this.querySelector('.custom-bb-onetime-link');
    
    this.bindEvents();
    
    const checkedOption = this.form.querySelector('input[type="radio"]:checked');
    if (checkedOption) {
      checkedOption.dispatchEvent(new Event('change'));
    }
  }

  bindEvents() {
    this.options.forEach(option => {
      const radio = option.querySelector('input[type="radio"]');
      if(radio) {
        radio.addEventListener('change', () => {
          if(radio.checked) {
            this.options.forEach(opt => opt.classList.remove('is-selected'));
            option.classList.add('is-selected');
            if (this.qtyInput) this.qtyInput.value = option.dataset.qty;
            if (this.spInput) {
              this.spInput.value = option.dataset.sp || "";
              if (!option.dataset.sp) {
                this.spInput.disabled = true;
              } else {
                this.spInput.disabled = false;
              }
            }
            if (this.idInput) this.idInput.value = option.dataset.vid;
            
            if (option.dataset.sp === "") {
              if (this.submitBtn) this.submitBtn.textContent = `Add To Cart - ${option.dataset.subprice}`;
            } else {
              if (this.submitBtn) this.submitBtn.textContent = `Add To Cart - ${option.dataset.subprice}/Mo`;
            }

            if (option.dataset.otprice) {
              if (this.oneTimeView) {
                const otOption = this.oneTimeView.querySelector('.custom-bb-option');
                if (otOption) {
                  otOption.dataset.qty = option.dataset.qty;
                  otOption.dataset.vid = option.dataset.vid;
                  otOption.dataset.subprice = option.dataset.otprice;
                  const otName = otOption.querySelector('.custom-bb-name');
                  if (otName) otName.textContent = option.dataset.otname;
                  const otPrice = otOption.querySelector('.custom-bb-price');
                  if (otPrice) otPrice.textContent = option.dataset.otprice;
                }
              }
              if (this.oneTimeLink) {
                this.oneTimeLink.textContent = `Buy Once for ${option.dataset.otprice} (${option.dataset.otpouches})`;
              }
            }
          }
        });
      }
    });

    if (this.oneTimeLink) {
      this.oneTimeLink.addEventListener('click', () => {
        if (!this.form) return;

        const otRadio = this.oneTimeView?.querySelector('input[type="radio"]');
        const otOption = otRadio?.closest('.custom-bb-option');
        if (!otOption) return;

        const prevQty = this.qtyInput?.value;
        const prevId = this.idInput?.value;
        const prevSp = this.spInput?.value;
        const prevSpDisabled = this.spInput?.disabled;

        if (this.qtyInput) this.qtyInput.value = otOption.dataset.qty;
        if (this.idInput) this.idInput.value = otOption.dataset.vid;
        if (this.spInput) {
          this.spInput.value = "";
          this.spInput.disabled = true;
        }

        this.form.requestSubmit();

        if (this.qtyInput) this.qtyInput.value = prevQty;
        if (this.idInput) this.idInput.value = prevId;
        if (this.spInput) {
          this.spInput.value = prevSp;
          this.spInput.disabled = prevSpDisabled;
        }
      });
    }
  }
}
customElements.define('new-custom-buy-box', NewCustomBuyBox);

class NewCustomReviewsSlider extends HTMLElement {
  constructor() {
    super();
    this.flickityNode = this.querySelector('.ncr-flickity');
    this.progressBar = this.querySelector('.ncr-progress-bar');
    this.itemsDesktop = this.dataset.itemsDesktop || 4;
    this.itemsMobile = this.dataset.itemsMobile || 1.2;
    this.initSlider();
    this.initVideos();
  }

  initSlider() {
    if (!this.flickityNode) return;
    
    const showArrows = this.dataset.showArrows === 'true';
    const infiniteLoop = this.dataset.infiniteLoop === 'true';

    let checkExist = setInterval(() => {
      if (typeof Flickity !== 'undefined') {
        clearInterval(checkExist);
        
        this.flkty = new Flickity(this.flickityNode, {
          cellAlign: 'left',
          contain: !infiniteLoop,
          wrapAround: infiniteLoop,
          pageDots: false,
          prevNextButtons: showArrows,
          groupCells: 1
        });

        if (showArrows) {
          this.initArrows();
        }

        if (this.progressBar) {
          this.flkty.on('scroll', (progress) => {
            progress = Math.max(0, Math.min(1, progress));
            this.progressBar.style.left = (progress * 100) + '%';
            this.progressBar.style.transform = `translateX(-${progress * 100}%)`;
          });
        }
      }
    }, 100);
  }

  initArrows() {
    let checkExist = setInterval(() => {
      let buttons = this.querySelectorAll('.flickity-prev-next-button');
      let snippet = this.querySelector('#ncr-arrow-snippet');
      if (buttons.length > 0 && snippet) {
        clearInterval(checkExist);
        let svgHtml = snippet.innerHTML;
        buttons.forEach(btn => {
          if (btn.classList.contains('previous')) {
            btn.innerHTML = svgHtml.replace('<svg ', '<svg style="transform: rotate(180deg); transform-origin: center;" ');
          } else {
            btn.innerHTML = svgHtml;
          }
        });
      }
    }, 100);
  }

  initVideos() {
    const videoCards = this.querySelectorAll('.ncr-video-card');
    videoCards.forEach(card => {
      const video = card.querySelector('video');
      const playBtn = card.querySelector('.ncr-video-play');
      const cover = card.querySelector('.ncr-video-cover');
      
      if (video && playBtn) {
        card.addEventListener('click', (e) => {
          if (e.target.closest('.ncr-product-badge')) return;
          
          if (video.paused) {
            video.play();
            playBtn.style.opacity = '0';
            if (cover) cover.style.opacity = '0';
          } else {
            video.pause();
            playBtn.style.opacity = '1';
            if (cover) cover.style.opacity = '1';
          }
        });
      }
    });
  }
}
customElements.define('new-custom-reviews-slider', NewCustomReviewsSlider);
